/**
 * partnerColorIconSingleton.js
 * Created by Destin Frasier 02/21/18
 */

import { IconSingleton } from '../iconSingleton';

class PartnerColorIconSingleton extends IconSingleton {
    constructor() {
        super();

        this.notificationName = 'icons-partner.loaded';
        this.svgPath = `${process.env.CDN}/graphics/partnerColorIcons.svg`;
    }
}

const instance = new PartnerColorIconSingleton();
export default instance;
